import React from 'react';
import {Card, Row, Col, message, Modal, Button, Form, Select as _Select, Icon, Typography} from 'antd';
import * as etiquetas from '../../ApplicationResources';
import axios from 'axios';
import errorImgModal from '../../img/error_icon.svg';
import Select from '../interfaz/Select';

const { Text } = Typography;
const { Option } = _Select;

class DatosSeleccionProceso extends React.Component {

    constructor(props) {
        // Calling the constructor of
        // Parent Class React.Component
        super(props);

        // Setting the initial state
        this.state = {
          msjError : "",
          abrirModalError : false,
          listaDetalles : null,
          detalleId: this.props.existeSesion ? parseInt(localStorage.getItem('id_detalle_proceso')) : "Selecciona una opción",
          procesoId: null,
        };
    }

    cerrarErrorModal(){
      this.setState({abrirModalError:false});
    }

    componentWillMount() {
		this.obtenerListaDetalles()
		.then(listaDetalles => {
			this.setState(
					{
                    listaDetalles: listaDetalles
					}
                );
                
                if(this.props.existeSesion) {
                    this.props.form.setFieldsValue({detalleId: parseInt(this.state.detalleId)});
                    this.props.wizard.current.cambiarEstado(1);
                }
		})
		.catch(error => {
		  console.error("Error al obtener lista de detalles procesos "+
			  "componentWillMount()",error);
		  
	
        });
        

    }

	/**
	* Obtiene la lista de los estados para el filtro de OC
	**/
	obtenerListaDetalles = async () =>{
		var postData = {
			"idEstado": this.props.existeSesion ? localStorage.getItem('id_estado') : 0
		};
		const detalles = await axios.post(process.env.REACT_APP_API_URL +
			"/centralReclutaSEyCAE/ws/obtenerDetalles", postData
					, {
							headers: {
								'Accept': 'application/json'
								 ,'Content-Type': 'application/json'
							}
					}
			);

			return JSON.parse(JSON.stringify(detalles.data));
    }
    
	handleDetalleChange = (detalleId) => {
		localStorage.setItem('id_detalle_proceso', detalleId);

		this.setState({
            detalleId:detalleId
		 });

		 this.obtenerProcesoElectoral();
    }
    
	obtenerProcesoElectoral(){
		var postData = {
				idDetalleProceso : localStorage.getItem('id_detalle_proceso')
			}

		  axios.post(process.env.REACT_APP_API_URL +
			"/centralReclutaSEyCAE/ws/obtenerProcesoElectoral", postData,
				{
					headers: {
					  'Accept': 'application/json',
					  'Content-Type': 'application/json'
					}
				}
			 ).then(response => {
			  this.setState({
						  procesoId : response.data !== null ?
										response.data : 0
					  });

			  localStorage.setItem('id_proceso_electoral', this.state.procesoId);
		  }).catch(error => {
			var msjError = "";
			console.error("Error al consultar el proceso electoral "+
				"obtenerProcesoElectoral()",error);
		  });
	}

    render() {
        return(
            <React.Fragment>
              <>
                <Card title={etiquetas.datos_seleccion_proceso_activo} bordered={false}>
{/*                     <Row gutter={16}>
                        <Col sm={24} md={24} lg={24}>
                            <Text style={{color: '#1890ff'}}>
                            <Icon type="info-circle" theme="filled"
                                    style={{fontSize: '1.0em'}} />
                                {etiquetas.datos_seleccion_proceso_cmbProceso_mensaje}
                            </Text>
                        </Col>
                    </Row> */}

                    <Row gutter={16}>
                        <Col sm={24} md={24} lg={24}>
                            <h3 className='encabezado_proceso_externo'>{etiquetas.datos_seleccion_proceso_cmbProceso}</h3>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col sm={24} md={24} lg={24}>
                            <Select nombre="detalleId"
                            placeholder="Selecciona una opción"
                            form={this.props.form}
                            required={true}
                            msjRequerido={etiquetas.general_dato_requerido}
                            onChange={this.handleDetalleChange}
                            showSearch={true}
                            value={this.state.detalleId}
                            selectedValue={this.state.detalleId}
                            >
                                {
                                    this.state.listaDetalles &&
                                    this.state.listaDetalles.map((detalle, index) => (
                                        <Option key={index} value={detalle.id}>
                                            {detalle.valor}
                                        </Option>
                                    ))
                                }
                            </Select>
                        </Col>
                    </Row>

                    

                    
                    
                </Card>

                <Modal
                  className="modalError"
                  title={<img  src={errorImgModal} id="img-error-modal"/>}
                  centered
                  onCancel={()=>this.cerrarErrorModal()}
                  visible={this.state.abrirModalError}
                  footer={false}
                  width={400}
                >
                  {this.state.msjError}
                </Modal>
                </>
           </React.Fragment>
        );
    }
};

export default DatosSeleccionProceso;
